/** Polished smiling girl avatar for Mayar chatbot */
export default function MayarAvatar({ className = 'h-10 w-10', title = 'Mayar' }) {
  return (
    <svg
      viewBox="0 0 80 80"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="mayarBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8B2E4A" />
          <stop offset="100%" stopColor="#5A1530" />
        </linearGradient>
        <linearGradient id="mayarSkin" x1="30%" y1="20%" x2="70%" y2="90%">
          <stop offset="0%" stopColor="#F8D5B8" />
          <stop offset="100%" stopColor="#E8B894" />
        </linearGradient>
        <linearGradient id="mayarHair" x1="20%" y1="0%" x2="80%" y2="100%">
          <stop offset="0%" stopColor="#3D2218" />
          <stop offset="100%" stopColor="#1A0F0C" />
        </linearGradient>
        <clipPath id="mayarClip">
          <circle cx="40" cy="40" r="40" />
        </clipPath>
      </defs>

      <g clipPath="url(#mayarClip)">
        <circle cx="40" cy="40" r="40" fill="url(#mayarBg)" />

        {/* soft glow */}
        <circle cx="40" cy="48" r="28" fill="#fff" opacity="0.08" />

        {/* hair back / shoulders */}
        <ellipse cx="40" cy="72" rx="28" ry="14" fill="#F5E6EA" />
        <path
          d="M12 42c-1 18 6 34 14 38 2-14 4-28 6-38-7-2-14-2-20 0z"
          fill="url(#mayarHair)"
        />
        <path
          d="M68 42c1 18-6 34-14 38-2-14-4-28-6-38 7-2 14-2 20 0z"
          fill="url(#mayarHair)"
        />

        {/* neck */}
        <rect x="34" y="54" width="12" height="12" rx="4" fill="#E0A888" />

        {/* face */}
        <ellipse cx="40" cy="40" rx="18" ry="20" fill="url(#mayarSkin)" />

        {/* bangs */}
        <path
          d="M22 36c1-14 10-22 18-22s17 8 18 22c-5-8-11-11-18-11s-13 3-18 11z"
          fill="url(#mayarHair)"
        />
        <path
          d="M24 28c4-2 8-1 10 2 1-4 5-7 10-7 3 0 6 1 8 4-2-8-9-13-18-13-10 0-17 6-18 14 2-1 5-1 8 0z"
          fill="url(#mayarHair)"
        />
        {/* hair highlight */}
        <path
          d="M30 18c3-1 7-1 10 0-1 2-4 3-7 3-2 0-3-1-3-3z"
          fill="#5C3A2A"
          opacity="0.55"
        />

        {/* eyebrows */}
        <path d="M30 33c2.5-1.5 6-1.5 8 0" fill="none" stroke="#2A1810" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M42 33c2.5-1.5 6-1.5 8 0" fill="none" stroke="#2A1810" strokeWidth="1.4" strokeLinecap="round" />

        {/* eyes */}
        <ellipse cx="34" cy="39.5" rx="3.2" ry="3.8" fill="#1A1010" />
        <ellipse cx="46" cy="39.5" rx="3.2" ry="3.8" fill="#1A1010" />
        <circle cx="35" cy="38.2" r="1.15" fill="#fff" />
        <circle cx="47" cy="38.2" r="1.15" fill="#fff" />
        <circle cx="33.2" cy="40.5" r="0.45" fill="#fff" opacity="0.7" />
        <circle cx="45.2" cy="40.5" r="0.45" fill="#fff" opacity="0.7" />

        {/* soft lashes */}
        <path d="M30.5 37.2c-1.2-.8-2-.6-2.4-.2" fill="none" stroke="#1A1010" strokeWidth="1" strokeLinecap="round" />
        <path d="M49.5 37.2c1.2-.8 2-.6 2.4-.2" fill="none" stroke="#1A1010" strokeWidth="1" strokeLinecap="round" />

        {/* nose */}
        <path d="M40 42.5c.8 1.6 1.6 2.2 0 2.4" fill="none" stroke="#C98A6E" strokeWidth="1.1" strokeLinecap="round" />

        {/* smile */}
        <path
          d="M33 48.5c2.2 3.2 11.8 3.2 14 0"
          fill="none"
          stroke="#C45C4A"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M35.5 49c1.5 1.6 7.5 1.6 9 0"
          fill="#F2A8A0"
          opacity="0.35"
        />

        {/* blush */}
        <ellipse cx="27.5" cy="45.5" rx="3.2" ry="1.8" fill="#F0A090" opacity="0.55" />
        <ellipse cx="52.5" cy="45.5" rx="3.2" ry="1.8" fill="#F0A090" opacity="0.55" />
      </g>
    </svg>
  )
}
